import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import _ from 'lodash';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { Tooltip } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import {
    DataGrid,
} from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CarrierTracking from './CarrierTracking'
import LinearProgress from '@mui/material/LinearProgress';
import NorowsData from '../../pages/General/NorowsData'
import AddLineItem from '../../pages/General/NewOrder/AddLineItem';
import Notification from '../../pages/General/Notification';
import { orderUpdateData,resetOrderNotifications } from '../../pages/Orders/ordersSlice';
import {
    fetchOrderDetail
} from '../../pages/OrderDetail/orderdetailsSlice';
const getUniqueId = () => {
    return "SCIT" + Date.now().toString(36) + Math.random().toString(36).substr(2)
}
const OrderDetailsEditDrawer = ({ visible,onClose,values,dispatchInputChangeCallback,errors,lineItemsData  }) => {
    const dispatch = useDispatch();
    const orderDetails = useSelector(state => state.orderdetails);
    const orderUpdate = useSelector(state => state.orders && state.orders.orderUpdate);
    const [editLineItemId, setEditLineItemId] = useState("")
    const [addLineItemVisible, setAddLineItemVisible] = useState(false)
    const [removeLineItemId, setRemoveLineItemId] = useState("")
    const [customLineItems, setCustomLineItems] = useState(lineItemsData)
    const [updateLineItems, setUpdateLineItems] = useState(lineItemsData)

    const [addLineItemData, setaddLineItemData] = useState({
        "line_item_id": getUniqueId(),
        "product_id": "",
        "product_desc": "",
        "product_url": "",
        "product_price": "",
        "hs_tariff_code": "",
        "hs_tariff_code_country": "",
        "edit_line_item_id": "",
        "quantity": 1,
        "tracking_number":"",
        "origin_country_code":""
    })

    const [lineItemErrors, setLineItemsErrors] = useState({
        "line_item_id": "",
        "product_id": "",
        "product_desc": "",
        "product_url": "",
        "product_price": "",
        "hs_tariff_code": "",
        "hs_tariff_code_country": "",
        "quantity": "",
        "origin_country_code":""
    });

    const handleInputChange = e => {
        const { name, value } = e.target
        dispatchInputChangeCallback(name, value)
    }

    const ondrawerclose = () => {
        onClose(false);
    }

    const isFloatValue = (value) => {
        value = Number(value);
        if (!isNaN(value) && value.toString().indexOf('.') != -1) {
            return true;
        }
        return false;
    }
    const isIntegerValue = (value) => {
        value = Number(value);
        if (Number.isInteger(value)) {
            return true;
        }
        return false;
    }
    const validateLineItemData = () => {
        let isValid = true
        let lineItemErrorsTemp = {
            "line_item_id": "",
            "product_id": "",
            "product_desc": "",
            "product_url": "",
            "product_price": "",
            "hs_tariff_code": "",
            "hs_tariff_code_country": "",
            "origin_country_code":"",
            "quantity": ""
        };

        if (addLineItemData.product_id == "" || addLineItemData.product_id.length >= 25) {
            isValid = false
            lineItemErrorsTemp.product_id = "Product id is required";
        }

        if (addLineItemData.product_desc == "" || addLineItemData.product_desc.length <= 1 || addLineItemData.product_desc.length >= 100) {
            isValid = false
            lineItemErrorsTemp.product_desc = "Product desc is required and should be more than 5 character long";
        }

        if (addLineItemData.product_url == "" || addLineItemData.product_url.length >= 250) {
            isValid = false
            lineItemErrorsTemp.product_url = "Product url is required and should be valid";
        }

        if (addLineItemData.product_price == "" || (!isFloatValue(addLineItemData.product_price) && !isIntegerValue(addLineItemData.product_price))) {
            isValid = false
            lineItemErrorsTemp.product_price = "Product price is required and should be valid";
        }

        if (addLineItemData.quantity == "" || !isIntegerValue(addLineItemData.quantity)) {
            isValid = false
            lineItemErrorsTemp.quantity = "Product quantity is required and should be a valid";
        }

        setLineItemsErrors(lineItemErrorsTemp)
        return isValid
    }

    const formDataHandler = e => {
        const { name, value } = e.target
        setaddLineItemData({
            ...addLineItemData,
            [name]: value
        })
        validateLineItemData();
    }

    const onAddLineItemModalClose = () => {
        setRemoveLineItemId("")
        setEditLineItemId("")
        setaddLineItemData({
            "line_item_id": getUniqueId(),
            "product_id": "",
            "product_desc": "",
            "product_url": "",
            "product_price": "",
            "hs_tariff_code": "",
            "hs_tariff_code_country": "",
            "edit_line_item_id": "",
            "quantity": 1,
            "tracking_number":"",
            "origin_country_code":""
        })
        setLineItemsErrors({
            "line_item_id": "",
            "product_id": "",
            "product_desc": "",
            "product_url": "",
            "product_price": "",
            "hs_tariff_code": "",
            "hs_tariff_code_country": "",
            "origin_country_code":"",
            "quantity": ""
        })
        setAddLineItemVisible(false)
    }

    const dispatchCountryCode = (id) => {
        setaddLineItemData({
            ...addLineItemData,
            ['origin_country_code']: id
        })
        validateLineItemData();
    }

    const onAddLineItemClick = () => {
        if (validateLineItemData()) {
            let customLineItemData = [...customLineItems];
            if (_.isUndefined(_.find(customLineItems, ['product_id', addLineItemData.product_id])) && addLineItemData.edit_line_item_id == "") {
                customLineItemData.push(addLineItemData)
                setCustomLineItems(customLineItemData)
                setaddLineItemData({
                    "line_item_id": getUniqueId(),
                    "product_id": "",
                    "product_desc": "",
                    "product_url": "",
                    "product_price": "",
                    "hs_tariff_code": "",
                    "hs_tariff_code_country": "",
                    "edit_line_item_id": "",
                    "origin_country_code":"",
                    "quantity": 1
                })
            } else if (addLineItemData.edit_line_item_id != "") {
                let editCheckData = _.find(customLineItems, ['line_item_id', addLineItemData.edit_line_item_id])
                if (editCheckData["product_id"] != addLineItemData.product_id && !_.isUndefined(_.find(customLineItems, ['product_id', addLineItemData.product_id]))) {
                    console.log("Product already exists")
                    setLineItemsErrors({
                        ...lineItemErrors,
                        [`product_id`]: "Product id already exists"
                    })
                    return false
                }
                let customLineItemData = [...customLineItems];
                let newLineItemData = [];
                customLineItemData.map((item) => {
                    if (item && item.line_item_id && item.line_item_id == addLineItemData.edit_line_item_id) {
                        newLineItemData.push(addLineItemData)
                    } else {
                        newLineItemData.push(item)
                    }
                })
                setCustomLineItems(newLineItemData)
            } else {
                console.log("Product already exists")
                setLineItemsErrors({
                    ...lineItemErrors,
                    [`product_id`]: "Product id already exists"
                })
                return false;
            }
            onAddLineItemModalClose()

        } else {
            console.log("Errors in line items")
        }
    }

    const updateButtonDisable = (item) => {
        let updateButtonDisable = true;
            if (!item.tracking_number || item.tracking_number === "") {
                updateButtonDisable = false;
            }
        return updateButtonDisable;
    }
    const onLineItemsChange = (items) => {
        if (items) {
            let productLineItem = []
            items && items.map((item) => {
                if (item) {
                    let product_id = 1;
                    if(item && item.product_id && item.product_id != ""){
                        product_id = item.product_id;
                    }else if(item && item.sku && item.sku != ""){
                        product_id = item.sku;
                    }
                    productLineItem.push({
                        "line_item_id": (item && item.line_item_id && item.line_item_id != "") ? item.line_item_id : "1",
                        "product_id": product_id,
                        "product_desc": (item && item.product_desc && item.product_desc != "") ? item.product_desc : "Product 1",
                        "product_url": (item && item.product_image && item.product_image != "") ? item.product_image : "https://www.shippingchimp.com/",
                        "product_price": (item && item.product_price && item.product_price != "") ? item.product_price : "100",
                        "hs_tariff_code": (item && item.hs_tariff_code && item.hs_tariff_code != "") ? item.hs_tariff_code : "",
                        "hs_tariff_code_country": (item && item.hs_tariff_code_country && item.hs_tariff_code_country != "") ? item.hs_tariff_code_country : "",
                        "quantity": (item && item.quantity && item.quantity != "") ? item.quantity : 1,
                        "tracking_number": (item && item.tracking_number && item.tracking_number != "" ) ? item.tracking_number : "",
                        "origin_country_code":(item && item.origin_country_code && item.origin_country_code != "") ? item.origin_country_code : ""
                    })
                }
            })
            setCustomLineItems(productLineItem)
        }
    }

    const handleSubmit=()=>{
        let originalData=updateLineItems
        let originalData2=[]
        customLineItems && customLineItems.map((item) => {
            for (let element = 0; element <= originalData.length; element++) {
                if(originalData && originalData[element] && originalData[element].line_item_id===item.line_item_id){
                    let product_desc=item.product_desc
                    let product_id=item.product_id
                    let product_url=item.product_url
                    let product_price=item.product_price
                    let quantity=item.quantity
                    let origin_country_code=item.origin_country_code
                    let hs_tariff_code=item.hs_tariff_code
                    let hs_tariff_code_country=item.hs_tariff_code_country
                    originalData2.push({...originalData[element],product_desc,product_id,product_url,product_price,quantity,origin_country_code,hs_tariff_code,hs_tariff_code_country})
                    break
                }
            }
            let checkExists = originalData2.some(el => el.line_item_id === item.line_item_id);
            if(checkExists===false){
                originalData2.push(item)
            }
        })
        let orderid=orderDetails && orderDetails.data && orderDetails.data.order_details && orderDetails.data.order_details.orderid
        let data={
            "lineItems":originalData2,
            "customer_info":values,
            "doc_id":orderDetails && orderDetails.data && orderDetails.data.doc_id,
            "orderid":orderid,
        }
        dispatch(orderUpdateData(data,orderid))
    }

    useEffect(() => {
        if (lineItemsData.length != 0) {
            onLineItemsChange(lineItemsData)
        }
    }, [lineItemsData])

    useEffect(() => {
        if (orderUpdate && orderUpdate.notification && orderUpdate.notification.messageContent && orderUpdate.notification.messageContent[0] === 'Order updated successfully') {
            dispatch(fetchOrderDetail(orderDetails && orderDetails.data && orderDetails.data.order_details && orderDetails.data.order_details.orderid));
        }
    }, [orderUpdate])

    useEffect(() => {
        if (removeLineItemId != "" && removeLineItemId != "undefined") {
            let customLineItemData = [...customLineItems];
            let newLineItemData = [];
            customLineItemData.map((item) => {
                if (item && item.line_item_id && item.line_item_id != removeLineItemId) {
                    newLineItemData.push(item)
                }
            })
            setCustomLineItems(newLineItemData)
        }
    }, [removeLineItemId])

    useEffect(() => {
        if (editLineItemId != "" && editLineItemId != "undefined" && !_.isUndefined(_.find(customLineItems, ['line_item_id', editLineItemId]))) {
            console.log("Found edit")
            let editData = _.find(customLineItems, ['line_item_id', editLineItemId])
            editData[`edit_line_item_id`] = editLineItemId
            setaddLineItemData(editData)
            setAddLineItemVisible(true)
        }
    }, [editLineItemId])

    const columns = [
        {
            field: 'product_id',
            headerName: 'Product Id',
            sortable: false,
            flex: 1,
            renderCell: (params) => {
                if (params.row.product_id && typeof params.row.product_id !== "undefined") {
                    return params.row.product_id
                } else {
                    return "-"
                }
            }
        },
        {
            field: 'product_desc',
            headerName: 'Product Desc',
            sortable: false,
            flex: 1,
            renderCell: (params) => {
                if (params.row.product_desc && typeof params.row.product_desc !== "undefined") {
                    return <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{params.row.product_desc}</span>
                } else {
                    return "-"
                }
            }
        },
        {
            field: 'tracking_number',
            headerName: 'Tracking Number',
            sortable: false,
            flex: 1,
            renderCell: (params) => {
                let tracking_number = (params.row.tracking_number && typeof params.row.tracking_number !== "undefined" && params.row.tracking_number !== null)
                    ? params.row.tracking_number : "";
                let carrier_name = (params.row.fulfilment_company && typeof params.row.fulfilment_company !== "undefined" && params.row.fulfilment_company !== null)
                    ? params.row.fulfilment_company : "";
                let tracking = { "tracking_number": tracking_number, "carrier_name": carrier_name }
                return (
                    <CarrierTracking trackingItems={tracking} carrierImageWidth="60px" />
                )
            }
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            sortable: false,
            flex: 1,
            renderCell: (params) => {
                if (params.row.quantity && typeof params.row.quantity !== "undefined") {
                    return params.row.quantity
                } else {
                    return "-"
                }
            }
        }, {
            field: 'action',
            headerName: 'Action',
            headerClassName: 'super-app-theme--header',
            width: 100,
            hide: (customLineItems.length == 0),
            renderCell: (params) => {
                if (params.row && params.row.line_item_id && params.row.line_item_id != "") {
                    return <>
                        <span>
                            <Tooltip title="Edit" placement="left-start" disableFocusListener={false}>
                                <IconButton>
                                    <EditIcon style={{  color: 'rgba(0,0,0,.54)', cursor: updateButtonDisable(params.row) ? 'not-allowed' : 'pointer', pointerEvents: updateButtonDisable(params.row) ? 'auto' : 'auto' }} onClick={() => {
                                        setEditLineItemId(params.row.line_item_id)
                                        }
                                        } />
                                </IconButton>
                            </Tooltip>
                        </span>
                        <span>
                            <Tooltip title="Delete" placement="left-start" disableFocusListener={false}>
                                <IconButton>
                                    <DeleteOutlineOutlinedIcon style={{  color: 'rgba(0,0,0,.54)', cursor: updateButtonDisable(params.row) ? 'not-allowed' : 'pointer', pointerEvents: updateButtonDisable(params.row) ? 'none' : 'auto' }}
                                        onClick={() => setRemoveLineItemId(params.row.line_item_id)}
                                    />
                                </IconButton>
                            </Tooltip>
                        </span>
                    </>;
                } else {
                    return <>-</>;
                }
            }
        }
    ]
    
    return (
        <>
            <Drawer
                anchor="right"
                open={visible}
                onClose={ondrawerclose}
                PaperProps={{
                    sx: { width: "70%" },
                }}
            >
                 {(orderUpdate && orderUpdate.notification && orderUpdate.notification.show) &&
                <Notification
                    is_open={orderUpdate.notification.show}
                    messageType={orderUpdate.notification.messageType}
                    messages={orderUpdate.notification.messageContent}
                    handleClose={() => dispatch(resetOrderNotifications())}
                />}

                {orderDetails && orderDetails.loading === true && <>
                    <Box style={{
                        position: 'absolute', left: '50%', top: '50%',
                        transform: 'translate(-50%, -50%)'
                    }}>
                        <CircularProgress />
                    </Box>
                </>
                }
                <AddLineItem
                    addLineItemVisible={addLineItemVisible}
                    onAddLineItemModalClose={onAddLineItemModalClose}
                    formDataHandler={formDataHandler}
                    dispatchCountryCode={dispatchCountryCode}
                    onAddLineItemClick={onAddLineItemClick}
                    addLineItemData={addLineItemData}
                    editLineItemId={editLineItemId}
                    errors={lineItemErrors}
                />
                {orderDetails && orderDetails.loading === false &&
                <div style={{ padding: "0 30px" }}>
                    <Card sx={{ margin: '20px 0' }} className="sc--cardhead--details">
                            <CardHeader title="Order Details Update" action={
                                <div>
                                    <IconButton aria-label="settings" onClick={ondrawerclose}>
                                        <CloseIcon />
                                    </IconButton>
                                </div>
                            } />
                             {(orderUpdate && orderUpdate.loading === true || orderUpdate.loading === true) &&
                                  <LinearProgress />
                            }
                            <Divider />
                            <CardContent>
                                <>
                                    <Grid
                                        container
                                        direction='row'
                                        spacing={1}
                                        alignnewOrderFormDatas="stretch"
                                >
                                        <Grid item xs={12} md={6} style={{ padding: '10px' }}>
                                            <Card sx={{ maxWidth: 1200 }}>
                                                <CardHeader title='Customer Information' className="sc--cardhead--details" />
                                                <Divider />
                                                <CardContent style={{ paddingBottom: '20px',paddingLeft:'16px',paddingRight:'16px' }}>
                                                <div className="sc--form--center">
                                                        <TextField id="standard-basic"
                                                            label="First name"
                                                            variant="standard"
                                                            name="customer_firstname"
                                                            value={values.customer_firstname}
                                                            onChange={handleInputChange}
                                                            error={errors.customer_firstname}
                                                            helperText={errors.customer_firstname}
                                                            style={{ width: "50%",marginRight: '8px' }} 
                                                        />
                                                        <TextField id="standard-basic"
                                                            label="Last Name"
                                                            variant="standard"
                                                            name="customer_lastname"
                                                            value={values.customer_lastname}
                                                            onChange={handleInputChange}
                                                            error={errors.customer_lastname}
                                                            helperText={errors.customer_lastname}
                                                            style={{ width: "50%" }} 
                                                        />
                                                    </div>
                                                    <TextField id="standard-basic"
                                                        label="Email"
                                                        variant="standard"
                                                        name="customer_email"
                                                        value={values.customer_email}
                                                        onChange={handleInputChange}
                                                        error={errors.customer_email}
                                                        helperText={errors.customer_email}
                                                        style={{ width: "100%" }} 
                                                    />
                                                    <TextField id="standard-basic"
                                                        label="Phone"
                                                        variant="standard"
                                                        name="customer_phone"
                                                        value={values.customer_phone}
                                                        onChange={handleInputChange}
                                                        error={errors.customer_phone}
                                                        helperText={errors.customer_phone}
                                                        style={{ width: "100%" }} 
                                                    />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} md={6} style={{ padding: '10px' }}>
                                            <Card sx={{ maxWidth: 1200 }}>
                                                <CardHeader title='DELIVERY ADDRESS' className="sc--cardhead--details" />
                                                <Divider />
                                                <CardContent style={{ paddingBottom: '20px',paddingLeft:'16px',paddingRight:'16px' }}>
                                                    <div className="sc--form--center">
                                                        <TextField id="standard-basic"
                                                            label="First name"
                                                            variant="standard"
                                                            name="receiver_first_name"
                                                            value={values.receiver_first_name}
                                                            onChange={handleInputChange}
                                                            error={errors.receiver_first_name}
                                                            helperText={errors.receiver_first_name}
                                                            style={{ width: "50%",marginRight: '8px' }} 
                                                        />
                                                        <TextField id="standard-basic"
                                                            label="Last Name"
                                                            variant="standard"
                                                            name="receiver_last_name"
                                                            value={values.receiver_last_name}
                                                            onChange={handleInputChange}
                                                            error={errors.receiver_last_name}
                                                            helperText={errors.receiver_last_name}
                                                            style={{ width: "50%" }} 
                                                        />
                                                    </div>
                                                    <TextField id="standard-basic"
                                                        label="Address1"
                                                        variant="standard"
                                                        name="company"
                                                        value={values.address1}
                                                        onChange={handleInputChange}
                                                        error={errors.address1}
                                                        helperText={errors.address1}
                                                        style={{ width: "100%" }} 
                                                    />
                                                    <div className="sc--form--center">
                                                        <TextField id="standard-basic"
                                                            label="Province"
                                                            variant="standard"
                                                            name="province"
                                                            value={values.province}
                                                            onChange={handleInputChange}
                                                            error={errors.province}
                                                            helperText={errors.province}
                                                            style={{ width: "50%",marginRight: '8px' }} 
                                                        />
                                                        <TextField id="standard-basic"
                                                            label="Zip"
                                                            variant="standard"
                                                            name="zip"
                                                            value={values.zip}
                                                            onChange={handleInputChange}
                                                            error={errors.zip}
                                                            helperText={errors.zip}
                                                            style={{ width: "50%" }} 
                                                        />
                                                    </div>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} md={12} style={{ padding: '10px' }}>
                                            <Card sx={{ maxWidth: 1200 }}>
                                                <CardHeader title='Product Details' className="sc--cardhead--details" 
                                                action={
                                                    <>
                                                            <Button variant="outlined" aria-label="settings" onClick={() => setAddLineItemVisible(true)}>
                                                                Add Line Item
                                                            </Button>
                                                    </>
                                                }/>
                                                <Divider />
                                                <CardContent className="sc--product--table">
                                                    <DataGrid
                                                        getRowId={(row) => row.line_item_id + Math.random()}
                                                        rows={customLineItems}
                                                        columns={columns}
                                                        autoHeight={true}
                                                        hideFooter={true}
                                                        components={{
                                                            NorowsData,
                                                            LoadingOverlay: LinearProgress,
                                                        }}
                                                        loading={
                                                            (orderDetails && orderDetails.loading)
                                                        }
                                                    />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <div className="sc--form--center" style={{ margin: '20px auto 0px auto' }}>
                                            <Button
                                                variant="outlined"
                                                onClick={handleSubmit}
                                                // disabled
                                                style={{ border: '1px solid rgba(0, 0, 0, 0.12)', margin: '0 15px' }}
                                            >
                                               Submit
                                            </Button>
                                        </div>
                                    </Grid>
                                </>
                            </CardContent>
                        </Card>
                </div>
                }
            </Drawer >
        </>
    )
}


export default OrderDetailsEditDrawer;